/* eslint-disable rxjs-x/finnish */
import { Provider } from '@angular/core';
import { TranslateLoader, TranslationObject, provideTranslateService } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';

import { DEFAULT_LANG } from '@shared/utils/locales';

export class TranslateWebpackLoader implements TranslateLoader {
  public getTranslation(_language: string): Observable<TranslationObject> {
    return from(this.getTranslationPromise());
  }

  private getTranslationPromise(): Promise<TranslationObject> {
    return import('../../i18n/en.json').then((webpackModule) => {
      return webpackModule.default as TranslationObject;
    });
  }
}

export const provideTranslate = (): Provider[] =>
  provideTranslateService({
    lang: DEFAULT_LANG,
    // Explicit provider object (not a bare class via provideTranslateLoader) so ngx-translate's
    // `isClass` heuristic never has to inspect the minified constructor. Under production
    // optimization, TranslateWebpackLoader gets minified to an anonymous class whose
    // `Function.prototype.toString()` output no longer starts with `class ` (no name/whitespace),
    // which makes `isClass` register it as `useFactory` instead of `useClass` — Angular then
    // invokes the class as a plain function, throwing
    // "Class constructor ... cannot be invoked without 'new'" at bootstrap.
    loader: { provide: TranslateLoader, useClass: TranslateWebpackLoader },
  });
